import { render, staticRenderFns } from "./HomeSpecialoffer.vue?vue&type=template&id=9f10efc6&scoped=true&"
import script from "./HomeSpecialoffer.vue?vue&type=script&lang=ts&"
export * from "./HomeSpecialoffer.vue?vue&type=script&lang=ts&"
import style0 from "./HomeSpecialoffer.vue?vue&type=style&index=0&id=9f10efc6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f10efc6",
  null
  
)

export default component.exports